module.exports = __webpack_public_path__ + "img/servicio-tecnico.f2368f18.jpg";